import { render, staticRenderFns } from "./dispatches.vue?vue&type=template&id=03f3af1e"
import script from "./dispatches.vue?vue&type=script&lang=ts"
export * from "./dispatches.vue?vue&type=script&lang=ts"
import style0 from "./dispatches.vue?vue&type=style&index=0&id=03f3af1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports